import { useState, useCallback, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs, TabList, Tab } from 'react-aria-components';
import { MapCz } from '@pages/sales-network/maps/MapCz';
import { MapSk } from '@pages/sales-network/maps/MapSk';
import TabPanel from '@pages/sales-network/shared/TabPanel';
import { AppLanguageCodes } from '@project-types/AppLanguageCodes';
import { SALES_NETWORK_LANGUAGES } from '@@/languageConfig';



const SalesNetwork = () => {
	const { t } = useTranslation([ 'web', 'forms' ]);

	const footerRef = useRef<HTMLDivElement>(null);
	const [ selectedRegion, setSelectedRegion ] = useState<string>('');


	useEffect(() => {
		if (selectedRegion !== '') {
			setTimeout(() => footerRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest' }), 150);
		}
	}, [ selectedRegion, footerRef ]);

	
	const handleRegionClick = useCallback((regionId: string) => {
		regionId === selectedRegion ? setSelectedRegion('') : setSelectedRegion(regionId);
	},[ selectedRegion ]);

	
	return (
		<div className="app-page sales-network-page">
			
			<h1>{t('pages.salesNetwork.header')}</h1>

			<Tabs>
				<TabList aria-label="Sales network countries">
					{SALES_NETWORK_LANGUAGES && SALES_NETWORK_LANGUAGES.map(x =>
						<Tab id={x} key={x}>{t(`shared.countries.${x}`, { ns: 'forms' })}</Tab>
					)}
				</TabList>
			
				<TabPanel country={AppLanguageCodes.CZ} selectedRegion={selectedRegion}>
					<MapCz
						selectedRegion={selectedRegion}
						onRegionClick={handleRegionClick} />
				</TabPanel>

				<TabPanel country={AppLanguageCodes.SK} selectedRegion={selectedRegion}>
					<MapSk
						selectedRegion={selectedRegion}
						onRegionClick={handleRegionClick} />
				</TabPanel>
			</Tabs>

		</div>
	);
};

export default SalesNetwork;